import {Component, Input} from '@angular/core'
import {ButtonModel} from '../../../../../../ui/button-group/button-group.component';

@Component({
  selector: 'shared-przedmiot-ubezpieczenia',
  templateUrl: './przedmiot-ubezpieczenia.component.html',
  styleUrls: ['przedmiot-ubezpieczenia.component.scss']
})
export class PrzedmiotUbezpieczeniaComponent {

  @Input()
  przedmiot!: ButtonModel

  @Input()
  czyAktywny!: boolean

  constructor() {}
}
